import { ViewTransition, type ReactNode } from "react";

interface ArtworkMorphProps {
    /** Shared between the artwork that was tapped and the podcast header it morphs into */
    name?: string;
    children: ReactNode;
}

/** Marks podcast artwork as a shared element; see global.css for the animation. */
export const ArtworkMorph = ({ name, children }: ArtworkMorphProps) => (
    <ViewTransition name={name} share="artwork-morph" default="none">
        {children}
    </ViewTransition>
);
